import { ChevronDown } from '@atom-learning/icons'
import * as NavigationMenuPrimitive from '@radix-ui/react-navigation-menu'
import React from 'react'

import { styled } from '~/styled'
import { cn } from '~/styled'
import { preventEvent } from '~/utilities/event/preventEvent'

import { Icon } from '../icon/Icon'
import {
  navigationMenuActiveItemStyles,
  navigationMenuBaseItemStyles
} from './NavigationMenu.styles'

const StyledTrigger = styled(NavigationMenuPrimitive.Trigger, {
  base: [
    ...navigationMenuBaseItemStyles,
    'flex',
    'items-center',
    'rounded-md',
    'justify-between',
    'data-[state=open]:bg-(--trigger-background-open)'
  ],
  variants: {
    active: {
      true: navigationMenuActiveItemStyles
    }
  }
})

export const NavigationMenuDropdownTrigger = React.forwardRef<
  HTMLButtonElement,
  React.ComponentProps<typeof StyledTrigger>
>(({ children, active, ...props }, forwardedRef) => (
  <StyledTrigger
    active={active}
    {...props}
    ref={forwardedRef}
    onPointerMove={preventEvent}
    onPointerLeave={preventEvent}
  >
    {children}
    <Icon
      is={ChevronDown}
      size="sm"
      className={cn(
        'ml-1',
        'in-data-[state=open]:-rotate-180',
        'motion-safe:duration-200',
        'motion-safe:ease-in',
        'motion-safe:transition-transform'
      )}
    />
  </StyledTrigger>
))

NavigationMenuDropdownTrigger.displayName = 'NavigationMenuDropdownTrigger'
